module.exports = __webpack_public_path__ + "img/rules-bg.68199cfe.jpg";